import React from "react";
import { EnterFullscreenIcon, ExitFullscreenIcon, SocialShareIcon, SubtitlesIcon, VolumeLoudIcon } from "../../../icons";
import { MenuButtonComponent } from "../common/MenuButtonComponent";

import "@styles/c-mobileMenu.scss";

interface Props {
  isSocialShareDisplayed: boolean;
  onSocialShareClicked: () => void;

  isFullscreenSupported: boolean;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;

  isVolumeMuted: boolean;
  onToggleMuted: () => void;

  hasSubtitles: boolean;
  selectedSubtitlesSrc?: string;
  onSubtitlesSelectorClicked: () => void;

  isDisabled?: boolean;
}

export const MobileMenuComponent: React.FC<Props> = (props) => {
  const {
    isSocialShareDisplayed,
    onSocialShareClicked,

    isFullscreenSupported,
    isFullscreen,
    onToggleFullscreen,

    isVolumeMuted,
    onToggleMuted,

    hasSubtitles,
    selectedSubtitlesSrc,
    onSubtitlesSelectorClicked,

    isDisabled,
  } = props;

  return (
    <div className="c-mobileMenu">
      {isSocialShareDisplayed && (
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onSocialShareClicked}
          icon={<SocialShareIcon />}
          isActive={!!selectedSubtitlesSrc}
        />
      )}
      {hasSubtitles && (
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onSubtitlesSelectorClicked}
          icon={<SubtitlesIcon />}
          isActive={!!selectedSubtitlesSrc}
        />
      )}

      {(isFullscreenSupported || (!isFullscreenSupported && window.self === window.top)) && (
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onToggleFullscreen}
          icon={isFullscreen ? <ExitFullscreenIcon /> : <EnterFullscreenIcon />}
        />
      )}

      {!isVolumeMuted && (
        <MenuButtonComponent className="c-mobileMenu__item" onClick={isDisabled ? () => {} : onToggleMuted} icon={<VolumeLoudIcon />} />
      )}
    </div>
  );
};
